/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Αντιγραφή'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Όνομα',
    PROFIT_MARGIN: 'Περιθώριο κέρδους'
  },
  LABEL: {
    GENERATE_LINK: 'Δημιουργία συνδέσμου',
    GENERATED_LINK: 'Παραγόμενος σύνδεσμος',
    NAME: 'Όνομα',
    PROFIT_MARGIN: 'Περιθώριο κέρδους'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Σύνδεσμος που αντιγράφηκε'
  },
  TOOLTIP: {
    NAME: 'Όνομα',
    PROFIT_MARGIN: 'Περιθώριο κέρδους'
  }
};
